import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { GhostButton } from 'ui/button';
import { JsonView } from 'ui/treeView';
import { Expand } from 'ui/icons/action/Expand';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { SettingsReadOnlyText } from 'modules/templateEditor/common/EditorContentContainer.styled';
import { useExpansionContext } from 'utils/contexts/expansion';
import { EmailContentDefinition } from 'modules/graphql';

const JsonViewWrapper = styled.div`
  border-radius: ${spacing.half};
  padding: ${spacing.base};
  border: ${spacing.single} solid ${colors.grey15};
  overflow: hidden;
  background-color: ${colors.grey10};
  position: relative;
`;

const StyledReadOnlyText = styled(SettingsReadOnlyText)`
  overflow-wrap: anywhere;
`;

const ExpandIconWrapper = styled(GhostButton)`
  position: absolute;
  bottom: ${({ theme }) => theme.spacing.values.half};
  right: ${({ theme }) => theme.spacing.values.half};
`;

const DISPLAY_CONTENT = {
  unset: 'Not set',
};

export const CustomPayloadPreview = () => {
  const { toggle } = useExpansionContext();
  const { liveTemplate } = useEditableFieldsContext();

  const { payload } = liveTemplate?.mediumData as EmailContentDefinition;
  const parsedJson = JSON.parse(payload ?? '{}');
  const isJsonView = payload !== '{}' && payload !== null;
  const hasNestedValues = !!Object.values(parsedJson).find((value) => typeof value === 'object');

  return isJsonView ? (
    <JsonViewWrapper>
      <JsonView data-test="custom-payload-preview-jsonView" src={parsedJson} showToggle={false} />
      {hasNestedValues && (
        <ExpandIconWrapper onClick={toggle}>
          <Expand color={colors.textSecondary} />
        </ExpandIconWrapper>
      )}
    </JsonViewWrapper>
  ) : (
    <StyledReadOnlyText isUnset data-test="raw-data-json-row">
      {DISPLAY_CONTENT.unset}
    </StyledReadOnlyText>
  );
};
